import { useTranslation } from 'react-i18next';

import { useCopyToClipboard } from 'src/hooks/useCopyToClipboard';
import { useReferralLink } from 'src/hooks/useReferralLink';

/** The workspace's referral link and a copy action that confirms in a toast. */
export function useCopyReferralLink() {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();
  const { referralLink } = useReferralLink();

  const copyReferralLink = async () => {
    await copyToClipboard(referralLink, {
      successMessage: t(($) => $.page_settings_referrals.link.copied),
    });
  };

  return { referralLink, copyReferralLink };
}
